var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAds(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12.89 4.205c.085.334.12.669.153.991l.031.294c.051.413.08 1.508.088 2.71.369.218.618.618.62 1.075.003.465-.25.87-.629 1.08-.013.867-.04 1.593-.079 1.915l-.03.304-.002.006c-.03.305-.06.621-.148.958-.233.797-.856 1.315-1.562 1.315l-.07-.001c-.39 0-.814-.24-1.055-.448l-2.343-1.952h-2.53c-.93 0-1.61-.672-1.733-1.711-.142-1.04-.114-2.823 0-3.768.135-.984.847-1.666 1.732-1.666h2.531l2.299-1.923c.277-.241.766-.48 1.153-.478.693 0 1.34.499 1.573 1.299zM7.22 14.454a.796.796 0 111.593 0v1.592a.796.796 0 11-1.593 0v-1.593zm.399-5.576a.398.398 0 00-.399.399v2.389a.398.398 0 00.797 0v-2.39a.398.398 0 00-.398-.398z"
  })));
}

export default SvgAds;